import { useEffect, useState } from 'react';

export type ResendEmailData = {
  cloudId?: string;
  cloudName?: string;
  email?: string;
  pagePath?: string;
  requestId?: string;
  resendCount: number;
  shouldEnable: boolean;
  primaryProduct?: string;
};

const useResendEmailData = (): [ResendEmailData, () => void] => {
  const [cloudId, setCloudId] = useState();
  const [cloudName, setCloudName] = useState<string | undefined>();
  const [email, setEmail] = useState<string | undefined>();
  const [primaryProduct, setPrimaryProduct] = useState<string | undefined>();
  const [pagePath, setPagePath] = useState();
  const [requestId, setRequestId] = useState();
  const [resendCount, setResendCount] = useState(0);
  const [shouldEnable, setShouldEnable] = useState(false);

  const setResendEmailData = (rawData: string | null) => {
    try {
      const parsedData = JSON.parse(rawData || '{}');
      setCloudId(parsedData.cloudId);
      setCloudName(decodeURIComponent(parsedData.cloudName || ''));
      setEmail(decodeURIComponent(parsedData.email || ''));
      setPrimaryProduct(decodeURIComponent(parsedData.primaryProduct || ''));
      setPagePath(parsedData.pagePath);
      setRequestId(parsedData.requestId);
      setResendCount(parsedData.resendCount || 0);
      setShouldEnable(isValidData(parsedData));
    } catch (e) {
      setCloudId(undefined);
      setCloudName(undefined);
      setEmail(undefined);
      setPrimaryProduct(undefined);
      setPagePath(undefined);
      setRequestId(undefined);
      setResendCount(0);
      setShouldEnable(false);
    }
  };

  const isValidData = (data: ResendEmailData): boolean => {
    return Boolean(
      data.cloudId &&
        data.cloudName &&
        data.email &&
        data.pagePath &&
        data.requestId &&
        data.primaryProduct
    );
  };

  const incrementCount = () => {
    setResendCount(resendCount + 1);
  };

  useEffect(() => {
    const rawData = sessionStorage.getItem('r.e.d');

    if (rawData) {
      try {
        setResendEmailData(atob(rawData));
      } catch {
        setResendEmailData(null);
      }
    }
  }, []);

  // update all data in sessionStorage whenever it changes.
  useEffect(() => {
    const data: ResendEmailData = {
      cloudId,
      cloudName: encodeURIComponent(cloudName || ''),
      email: encodeURIComponent(email || ''),
      pagePath,
      requestId,
      resendCount,
      shouldEnable,
      primaryProduct
    };
    if (isValidData(data)) {
      sessionStorage.setItem('r.e.d', btoa(JSON.stringify(data)));
    }
  }, [
    cloudId,
    cloudName,
    email,
    pagePath,
    requestId,
    resendCount,
    primaryProduct
  ]);

  return [
    {
      cloudId,
      cloudName,
      email,
      pagePath,
      requestId,
      resendCount,
      shouldEnable,
      primaryProduct
    },
    incrementCount
  ];
};

export default useResendEmailData;
